import { Box, Flex, Text } from '@mantine/core';
import { AskSiestaInput } from 'src/UI/app-container/sidebar/AskSiestaInput';
import { SiestaStepCard } from 'src/UI/generate-flow/SiestaStepCard';
import { SiestaStepCounter } from 'src/UI/generate-flow/SiestaStepCounter';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

const STEPS = [
  { title: 'Select at least 2 members to continue' },
  {
    title:
      'Enter a name to identify this family - typically the surname. If you have multiple families with the same surname, add a detail to distinguish them (e.g. "Smiths of Park Road")',
  },
  { title: 'Done' },
];

const cardStyle: React.CSSProperties = {
  borderRadius: 24,
  background: 'rgba(0,0,0,0.05)',
  backdropFilter: 'blur(50px)',
  border: '1px solid rgba(253,253,253,0.15)',
};

type Props = {
  step: 'select' | 'details';
};

export function CreateFamilySidebar({ step }: Props) {
  const currentStep = step === 'select' ? 1 : 2;

  return (
    <Flex direction="column" h="100%" justify="space-between" align="center" px="md" py="xl">
      <Box />

      <Flex direction="column" align="center" gap="xs" w="100%">
        <SiestaStepCounter currentStep={currentStep} totalSteps={STEPS.length - 1} />

        <SiestaStepCard steps={STEPS} currentStep={currentStep} dimmed={false} minimized={false} />

        {step === 'details' && (
          <Flex direction="column" gap="sm" w={374} mt="sm">
            <Box px="md" py="sm" style={cardStyle}>
              <Text c="white" size="xl" fw={FONT_WEIGHTS.bold} ta="center" opacity={0.8}>
                Defining relationships helps me understand joint assets, dependants, and planning
                context.
              </Text>
            </Box>
          </Flex>
        )}
      </Flex>

      <AskSiestaInput variant="light" />
    </Flex>
  );
}
